export const LOGIN_REQUEST: string = 'LOGIN_REQUEST';
export const VERIFY_REQUEST: string = 'VERIFY_REQUEST';
